module.exports = "<alk-main-nav></alk-main-nav>\r\n<div class=\"container with-nav terms-page\">\r\n    <div class=\"panel col-md-10 col-md-offset-1\">\r\n        <div class=\"page-content\">\r\n            <div class=\"terms-content\" ng-include=\"'/app/auth/' + language + '/termsContent.html'\"></div>\r\n        </div>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/auth/terms.html
// module id = 212
// module chunks = 0